import type { RouterLinkOptions } from '@/types/RouterLinkOptions';

export const BASE_LINKS: RouterLinkOptions[] = [
  { title: 'Verwaltung', link: { to: '/management' } },
  { title: 'Über diese Seite', link: { to: '/about' } },
  { title: 'Kontakt', link: { to: '/contact' } },
  { title: 'Häufige Fragen', link: { to: '/frequently-asked-questions' } },
  { title: 'Barrierefreiheit ', link: { to: '/accessibility' } },
  { title: 'Nutzungsbedingungen', link: { to: '/terms-of-use' } },
  { title: 'Datenschutz', link: { to: '/privacy' } },
  { title: 'Impressum', link: { to: '/imprint' } },
];
